import React, { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { CreateAndSendQuoteModal } from 'modules/quote';
import { SearchInventoryDialog } from 'modules/inventory';
import { DocuSignDialog } from 'modules/integrations/docuSign';
import { CreateProposalProductDialog } from 'modules/proposals';
import { CreatePartnerAccountDialog } from 'modules/aftermarket';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CreateUpdateInvoiceModal, UploadInvoiceDialog } from 'modules/invoice';
import { CloseDealWithReasonDialog, UpdateDealClosureDialog } from 'modules/stages';
import { FinanceProgramModal, PreviewFinanceProgramModal } from 'modules/financeProgram';
import {
  ActivityDialog,
  CallActivityDialog,
  NewMessageDialog,
  NoteActivityDialog,
  StartSubprimeAgentDialog,
} from 'modules/dealActivity';
import { UploadImagesForExistingEquipmentDialog, PreviewExistingImagesDialog } from 'modules/equipment';
import { CalculatedRevenueModal } from './tabs/revenue/CalculatedRevenueModal';

import PageOpportunityDetails from './PageOpportunityDetails';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.DocuSignDialog]: <DocuSignDialog />,
  [ModalsKeys.FinanceForm]: <FinanceProgramModal />,
  [ModalsKeys.UploadInvoiceDialog]: <UploadInvoiceDialog />,
  [ModalsKeys.CreateAndSendQuote]: <CreateAndSendQuoteModal />,
  [ModalsKeys.PreviewFinanceForm]: <PreviewFinanceProgramModal />,
  [ModalsKeys.CreateUpdateInvoiceDialog]: <CreateUpdateInvoiceModal />,
  [ModalsKeys.AftermarketCreatePartnerDialog]: <CreatePartnerAccountDialog />,
  [ModalsKeys.ProposalCreateProductDialog]: <CreateProposalProductDialog />,
  [ModalsKeys.PreviewExistingEquipmentImagesDialog]: <PreviewExistingImagesDialog />,
  [ModalsKeys.UploadImagesForExistingEquipmentDialog]: <UploadImagesForExistingEquipmentDialog />,
  [ModalsKeys.CalculatedRevenueDialog]: <CalculatedRevenueModal />,

  [ModalsKeys.ActivityDialog]: <ActivityDialog />,
  [ModalsKeys.CallActivityDialog]: <CallActivityDialog />,
  [ModalsKeys.NoteActivityDialog]: <NoteActivityDialog />,
  [ModalsKeys.NewMessageDialog]: <NewMessageDialog />,
  [ModalsKeys.StartSubprimeAgentDialog]: <StartSubprimeAgentDialog />,

  [ModalsKeys.SearchInventoryDialog]: <SearchInventoryDialog />,

  [ModalsKeys.CloseDealDialog]: <CloseDealWithReasonDialog />,
  [ModalsKeys.UpdateDealClosureDialog]: <UpdateDealClosureDialog />,
};

export const PageOpportunityDetailsContainer = () => (
  <PageContainer modals={modalsWithKeys} title="Opportunity Details">
    <PageOpportunityDetails />
  </PageContainer>
);
